<div class="classic-game-container tab-container">
  <app-winner-alert
    *ngIf="showRushWinnerResult"
    [show]="showRushWinnerResult"
    [chips]="totalEarning.earned"
    [bonus]="0"
    (onEnded)="hideRushWinnerResult()"
    bet="{{ getBetTypeKey(gameResult?.result) }}"
  ></app-winner-alert>
  <app-stream class="stream-container"></app-stream>
  <div>
    <app-bet-header class="bet-header-container"></app-bet-header>
    <app-pot class="pot-container"></app-pot>

    <div class="fit-content relative md:static">
      <app-please-stand-by *ngIf="standby" class="stand-by"></app-please-stand-by>
      <div class="betting-section">
        <app-deck-card class="deck-card-container"></app-deck-card>
        <app-bet-confirmation-alert
          [bet]="currentBetType"
          [chips]="currentBetChips"
          [show]="betLocked"
          (onEnded)="betConfirmed = false"
          *ngIf="betLocked"
        ></app-bet-confirmation-alert>
        <app-buy-in-alert
          [show]="buyInConfirmed"
          [amount]="_classicService.activeTable.buyInCost"
          (onEnded)="buyInConfirmed = false"
          *ngIf="buyInConfirmed"
        ></app-buy-in-alert>
        <app-betting-section class="bet-container"></app-betting-section>
      </div>
    </div>
    <app-game-history-mobile class="history-container-mobile md:hidden"></app-game-history-mobile>
  </div>
  <app-game-history-mobile class="history-container hidden md:block"></app-game-history-mobile>
</div>
